module.exports = __webpack_public_path__ + "img/gal_37.7925a8b6.png";